import PropTypes from 'prop-types'

export default PropTypes.shape({
  coordinates: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired
})
